<template>
  <v-card>
    <v-row>
      <!-- {{this.phonenumber }} -->
      <v-col cols="12" sm="12" md="12" lg="6">
        <v-col cols="12" sm="12" md="12" lg="12" class="pl-8">
          <v-select
            v-model="slectTo"
            :items="To"
            label="To"
            dense
            outlined
            item-text="name"
            item-value="id"
            @input="SelectPhoneNumber(slectTo)"
          >
          </v-select>
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="12" class="pl-8">
          <v-autocomplete
            v-if="mobileNumberVisible"
            v-model="phonenums"
            :disabled="isUpdating"
            :items="phonenumber"
            filled
            chips
            label="Mobile Number"
            item-text="id"
            item-value="phone"
            multiple
          >
            <template v-slot:selection="data">
              <v-chip
                v-if="CheckMobileNumbers(data.item)"
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="remove(data.item)"
              >
                {{ data.item.phone }}
              </v-chip>
            </template>
            <template v-slot:item="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-item-content v-text="data.item"></v-list-item-content>
              </template>
              <template v-else>
                <v-list-item-content>
                  <v-list-item-title
                    v-html="data.item.name"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-html="data.item.group"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="12" class="pl-8">
          <v-form>
            <v-textarea
              v-model="message"
              label="Message"
              counter
              maxlength="100"
              outlined
              dense
              hide-details="auto"
            >
            </v-textarea>
          </v-form>
          <v-col cols="12" class="text-right pa-0">
            <v-btn
              depressed
              small
              class="ml-1 text-white btn_medium"
              color="primary"
              @click="sendBulkMessage"
            >
              <v-icon left small> mdi-send </v-icon>Send</v-btn
            >
          </v-col>
        </v-col>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="6">
        <SmsTemplates @change="monthChanged" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { CustomerViewModel } from '../../models/View Models/CustomerViewModel';
import SmsTemplates from './SMSTempatesComponent.vue';
export default {
  data: () => {
    return {
      mobileNumberVisible: false,
      length: 1,
      slectTo: '',
      message: '',
      loading: '',
      To: [
        { id: 1, name: 'Customers' },
        { id: 2, name: 'Suppliers' },
        { id: 3, name: 'Users' },
      ],
      phonenums: [],
      isUpdating: false,
      phonenumber: [],
    };
  },

  components: {
    SmsTemplates,
  },
  methods: {
    monthChanged(data) {
      this.message = data;
    },
    remove(item) {
      const index = this.phonenums.indexOf(item.phone);
      if (index >= 0) this.phonenums.splice(index, 1);
    },
    SelectPhoneNumber(item) {
      this.mobileNumberVisible = true;
      this.loading = true;
      this.$store
        .dispatch('sms/GetPhoneNumbers', item)
        .then((res) => {
          this.phonenumber = res.data.data.map((u, i, arr) => {
            u.index = i + 1;
            return u;
          });
          this.phonenums = this.phonenumber.map((number) => {
            return number.phone;
          });
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    sendBulkMessage() {
      let phone = this.phonenums.toString();
      let bulkSMSData = {
        phoneNumber: phone,
        message: this.message,
      };
      this.isLoading = true;
      this.$store
        .dispatch('sms/SendSingleandBulkSMS', bulkSMSData)
        .then((res) => {
          if (res.data.message == 'Your SMS Notification is Disabled') {
            this.$toast.error(res.data.message);
          } else {
            this.$toast.success(res.data.message);
          }

          this.isLoading = false;
          (this.phonenums = []), (this.message = '');
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.$toast.error('Failed to send SMS');
          this.messages = err.data.title;
          this.isLoading = false;
        });
    },
    CheckMobileNumbers(item) {
      if (item.phone.length == 0) {
        return false;
      } else {
        if (item.phone.length > 8) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
};
</script>
